import { ChevronDown } from "lucide-react";
import { type ReactNode, useState } from "react";

import { Card } from "@/components/ui/card";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { cn } from "cn";
import type { Appointment } from "@/types/appointments/api-types/appointment-types";
import { useIntl } from "react-intl";
import { isoTime } from "@/lib/utils";

export function DataCard({ summary, children }: { summary: string; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <Collapsible open={open} onOpenChange={setOpen} asChild>
      <Card className="my-2 text-xs">
        <CollapsibleTrigger className="flex w-full items-center justify-between gap-2 p-3 text-left font-medium">
          <span>{summary}</span>
          <ChevronDown className={cn("size-3.5 shrink-0 transition-transform", open && "rotate-180")} />
        </CollapsibleTrigger>
        <CollapsibleContent className="flex flex-col gap-3 border-t p-3">{children}</CollapsibleContent>
      </Card>
    </Collapsible>
  );
}

export function CardSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-1">
      <p className="font-medium text-muted-foreground">{title}</p>
      {children}
    </div>
  );
}

export function ServiceLines({ appointment }: { appointment: Appointment }) {
  const intl = useIntl();
  return (
    <>
      {appointment.services.map((line) => (
        <p key={line.id}>
          {intl.formatTime(isoTime(line.start_time), { format: "clock" })} · {line.service_name} · {line.staff_name}
        </p>
      ))}
    </>
  );
}
